import { render, staticRenderFns } from "./RewardBookDialog.vue?vue&type=template&id=2a4abcbc&"
import script from "./RewardBookDialog.vue?vue&type=script&lang=js&"
export * from "./RewardBookDialog.vue?vue&type=script&lang=js&"
import style0 from "./RewardBookDialog.vue?vue&type=style&index=0&id=2a4abcbc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports